// utils/validation.jsx
const isPositiveNumber = (value) => !isNaN(value) && Number(value) > 0;

export const validateFields = (values, setFormState, t) => {
  const { title, description, servings, prepTime, cookTime } = values;
  const newErrors = {};

  if (!title) newErrors.title = t("validationErrors.titleRequired");
  if (!description) newErrors.description = t("validationErrors.descriptionRequired");

  if (!isPositiveNumber(servings)) newErrors.servings = t("validationErrors.positiveNumber");
  if (!isPositiveNumber(prepTime)) newErrors.prepTime = t("validationErrors.positiveNumber");
  if (!isPositiveNumber(cookTime)) newErrors.cookTime = t("validationErrors.positiveNumber");

  setFormState((prev) => ({
    ...prev,
    errors: newErrors,
  }));
  return Object.keys(newErrors).length === 0;
};

export const validateField = (name, value, t) => {
  let error = "";

  if (name === "quantity") {
    if (value && !isPositiveNumber(value)) {
      error = t("validationErrors.positiveNumber");
    }
  }

  return error;
};

export const handleFieldChange = (event, isNew, index, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t) => {
  const { name, value } = event.target;
  let updatedValue = value;

  if (name === "quantity") {
    // Replace comma with period for decimal numbers
    updatedValue = value.replace(",", ".");

    if (value && !isPositiveNumber(updatedValue)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: {
          ...(prevErrors[index] || {}),
          quantity: t("validationErrors.positiveNumber"),
        },
      }));
    } else {
      setErrors((prevErrors) => {
        // Safely handle the case when prevErrors[index] is undefined
        const currentIndexErrors = prevErrors[index] || {};
        const updatedIndexErrors = { ...currentIndexErrors, quantity: "" };

        // Only keep the index if there are other errors
        const hasRemainingErrors = Object.values(updatedIndexErrors).some((err) => !!err);

        return {
          ...prevErrors,
          [index]: hasRemainingErrors ? updatedIndexErrors : undefined,
        };
      });
    }
  }

  if (isNew) {
    setNewIngredient((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  } else {
    const updatedIngredients = ingredients.map((ingredient, i) => (i === index ? { ...ingredient, [name]: updatedValue } : ingredient));
    onIngredientsChange(updatedIngredients);
  }
};
